// Interactive branching stories for kids — Indonesian folklore + moral tales
// Format: each story has nodes. Each node has text, optional emoji image, and choices.
// Each choice points to next node id. Terminal nodes have ending="good"|"bad"|"neutral" and message.

export const STORIES = [
  {
    id: "kancil",
    title: "Si Kancil & Buaya",
    emoji: "🦌",
    desc: "Cerita kancil cerdik menyebrang sungai",
    color: "from-green-400 to-emerald-500",
    nodes: {
      start: {
        text: "Si Kancil ingin menyebrang sungai untuk mencari mentimun. Di sungai banyak buaya lapar!",
        emoji: "🦌🌊🐊",
        choices: [
          { label: "Berenang melewati buaya", next: "berenang" },
          { label: "Pakai tipu daya cerdik", next: "tipu" },
          { label: "Cari jembatan jauh", next: "jembatan" },
        ],
      },
      berenang: {
        text: "Aduh! Kancil hampir dimakan buaya! Kancil mundur. Ide buruk!",
        emoji: "😱",
        choices: [{ label: "Coba lagi", next: "start" }],
      },
      tipu: {
        text: "Kancil pintar! 'Hai buaya, raja mau kasih daging! Ayo berbaris berhitung!'",
        emoji: "🦌✨",
        choices: [
          { label: "Hitung sambil meloncat", next: "lompat" },
          { label: "Suruh buaya berenang ke seberang", next: "seberang" },
        ],
      },
      jembatan: {
        text: "Kancil jalan jauh, akhirnya sampai. Tapi mentimun sudah habis dipetik orang. Hm... Tidak buruk juga.",
        emoji: "😔",
        ending: "neutral", message: "Kamu pilih jalan aman, tapi mentimun habis!",
      },
      lompat: {
        text: "Kancil melompat dari punggung buaya satu ke buaya lain sambil berhitung. SUKSES! Sampai seberang!",
        emoji: "🎉🥒",
        ending: "good", message: "Kancil pintar! Berkat akal cerdik, ia sampai dan dapat mentimun!",
      },
      seberang: {
        text: "Buaya tidak mau dibodohi. Kancil harus cari cara lain.",
        emoji: "🐊😠",
        choices: [{ label: "Coba ide lain", next: "tipu" }],
      },
    },
  },
  {
    id: "malin",
    title: "Malin Kundang",
    emoji: "🪨",
    desc: "Cerita anak durhaka jadi batu",
    color: "from-blue-400 to-cyan-500",
    nodes: {
      start: {
        text: "Malin sudah jadi nahkoda kaya. Saat berlayar pulang, ia melihat ibunya yang sudah tua di pelabuhan.",
        emoji: "⛵👵",
        choices: [
          { label: "Akui ibu dan peluk", next: "akui" },
          { label: "Pura-pura tidak kenal", next: "ingkar" },
          { label: "Sembunyi di kapal", next: "sembunyi" },
        ],
      },
      akui: {
        text: "Malin turun, peluk ibunya. 'Maafkan aku, Bu!' Ibu menangis bahagia.",
        emoji: "🤗❤️",
        ending: "good", message: "Anak yang baik harus selalu menyayangi ibunya!",
      },
      ingkar: {
        text: "'Wanita tua siapa kamu? Pergi!' Ibu Malin menangis dan berdoa. Tiba-tiba badai datang!",
        emoji: "⛈️😢",
        choices: [
          { label: "Minta maaf segera", next: "maaf" },
          { label: "Tetap sombong", next: "batu" },
        ],
      },
      sembunyi: {
        text: "Ibu sedih karena tidak ketemu Malin. Malin tetap nyaman... Tapi hatinya gelisah.",
        emoji: "😔",
        ending: "neutral", message: "Sembunyi dari masalah tidak menyelesaikan apapun.",
      },
      maaf: {
        text: "Malin sadar dan minta maaf. Badai reda. Ibu memaafkan dengan air mata bahagia.",
        emoji: "🌈❤️",
        ending: "good", message: "Tidak ada kata terlambat untuk minta maaf!",
      },
      batu: {
        text: "Malin tetap sombong. Petir menyambar! Malin berubah jadi batu...",
        emoji: "🪨⚡",
        ending: "bad", message: "Jangan pernah durhaka pada orang tua!",
      },
    },
  },
  {
    id: "tikus",
    title: "Tikus & Singa",
    emoji: "🐭",
    desc: "Tolong-menolong itu penting",
    color: "from-yellow-400 to-orange-500",
    nodes: {
      start: {
        text: "Tikus kecil sengaja melewati hutan dan terbangunkan Singa yang sedang tidur!",
        emoji: "🐭🦁",
        choices: [
          { label: "Lari secepat mungkin", next: "lari" },
          { label: "Minta maaf baik-baik", next: "minta" },
          { label: "Bersembunyi", next: "sembunyi" },
        ],
      },
      lari: {
        text: "Singa marah! Tikus tertangkap. 'Tolong jangan makan aku, suatu hari aku akan membalas!'",
        emoji: "😨",
        choices: [{ label: "Mohon ampun", next: "ampun" }],
      },
      minta: {
        text: "Singa kaget tikus berani bicara. 'Hmm, kamu jujur. Pergilah!'",
        emoji: "🦁👍",
        ending: "good", message: "Kejujuran selalu jadi pilihan terbaik!",
      },
      sembunyi: {
        text: "Singa tidak melihat tikus, dan tertidur lagi. Tikus pun pulang...",
        emoji: "😌",
        ending: "neutral", message: "Aman, tapi tidak ada cerita seru hari ini.",
      },
      ampun: {
        text: "Singa tertawa, 'Tikus kecil mau bantu raja? Pergilah!' Tikus dibebaskan. Beberapa hari kemudian Singa kejebak jaring pemburu...",
        emoji: "🪤",
        choices: [
          { label: "Tikus pergi bantu Singa", next: "bantu" },
          { label: "Tikus lari ketakutan", next: "kabur" },
        ],
      },
      bantu: {
        text: "Tikus menggigit jaring sampai putus! Singa bebas dan jadi sahabat tikus selamanya.",
        emoji: "🐭🦁🤝",
        ending: "good", message: "Hewan kecil pun bisa menolong yang besar — tolong-menolong itu indah!",
      },
      kabur: {
        text: "Singa tidak ada yang menolong... Tikus menyesal seumur hidup.",
        emoji: "😢",
        ending: "bad", message: "Jangan lupa membalas kebaikan!",
      },
    },
  },
  {
    id: "timun",
    title: "Timun Mas",
    emoji: "🥒",
    desc: "Petualangan melawan raksasa",
    color: "from-pink-400 to-rose-500",
    nodes: {
      start: {
        text: "Timun Mas dikejar Raksasa! Ibu kasih 4 bungkus ajaib: biji timun, jarum, garam, terasi.",
        emoji: "🏃‍♀️👹",
        choices: [
          { label: "Lempar biji timun", next: "biji" },
          { label: "Lempar terasi langsung", next: "terasi" },
        ],
      },
      biji: {
        text: "Tumbuh hutan timun raksasa! Raksasa tersangkut, tapi masih mengejar...",
        emoji: "🌱",
        choices: [
          { label: "Lempar jarum", next: "jarum" },
          { label: "Lempar garam", next: "garam_dulu" },
        ],
      },
      terasi: {
        text: "Bau busuk! Tapi Raksasa malah kuat karena suka bau itu. Bahaya!",
        emoji: "🤢",
        ending: "bad", message: "Salah urutan! Coba pakai bijinya dulu.",
      },
      jarum: {
        text: "Berubah jadi hutan bambu tajam! Raksasa terluka tapi terus mengejar...",
        emoji: "🎋",
        choices: [
          { label: "Lempar garam", next: "garam" },
        ],
      },
      garam_dulu: {
        text: "Berubah jadi lautan! Raksasa basah kuyup tapi bisa berenang. Coba lagi!",
        emoji: "🌊",
        ending: "neutral", message: "Hampir berhasil! Urutannya: biji→jarum→garam→terasi.",
      },
      garam: {
        text: "Lautan luas! Raksasa kesusahan berenang...",
        emoji: "🌊",
        choices: [
          { label: "Lempar terasi", next: "menang" },
        ],
      },
      menang: {
        text: "Terasi berubah jadi lautan lumpur panas! Raksasa tenggelam. Timun Mas selamat!",
        emoji: "🎉",
        ending: "good", message: "Hebat! Urutan yang tepat: biji, jarum, garam, terasi!",
      },
    },
  },
  {
    id: "bawang",
    title: "Bawang Merah & Putih",
    emoji: "🧅",
    desc: "Kebaikan selalu dibalas",
    color: "from-purple-400 to-pink-500",
    nodes: {
      start: {
        text: "Bawang Putih disuruh ibu tirinya cuci baju di sungai. Bajunya hanyut!",
        emoji: "👕🌊",
        choices: [
          { label: "Susuri sungai", next: "susur" },
          { label: "Pulang menangis", next: "pulang" },
        ],
      },
      susur: {
        text: "Bawang Putih menemukan rumah Nenek. Nenek minta tolong dipijat & dibersihkan.",
        emoji: "👵🏠",
        choices: [
          { label: "Tolong dengan ikhlas", next: "tolong" },
          { label: "Bilang sibuk", next: "tidak" },
        ],
      },
      pulang: {
        text: "Ibu tiri marah besar! Bawang Putih dihukum tanpa makan malam.",
        emoji: "😢",
        ending: "bad", message: "Jangan menyerah, selalu coba selesaikan masalah!",
      },
      tolong: {
        text: "Nenek senang! Beri hadiah: pilih labu besar atau labu kecil?",
        emoji: "🎁",
        choices: [
          { label: "Labu kecil (rendah hati)", next: "kecil" },
          { label: "Labu besar (rakus)", next: "besar" },
        ],
      },
      tidak: {
        text: "Nenek kecewa. Tidak ada hadiah. Bawang Putih pulang dengan tangan kosong.",
        emoji: "😔",
        ending: "neutral", message: "Tolong-menolong itu indah, jangan ditolak!",
      },
      kecil: {
        text: "Labu kecil dibuka di rumah... PENUH EMAS DAN PERMATA!",
        emoji: "💎",
        ending: "good", message: "Kerendahan hati selalu dapat berkah!",
      },
      besar: {
        text: "Labu besar dibuka... berisi ular dan lebah! Bawang Putih takut tapi belajar tentang kerakusan.",
        emoji: "🐍",
        ending: "bad", message: "Jangan rakus, pilih yang sederhana dan tulus!",
      },
    },
  },
];
